/**
 * Layout exclusivo para Administradores
 */

import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import SidebarAdmin, { drawerWidth } from './SidebarAdmin';
import NavbarAdmin from './NavbarAdmin';

const LayoutAdmin = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#F1F5F9' }}>
      <CssBaseline />

      <NavbarAdmin handleDrawerToggle={() => setMobileOpen(!mobileOpen)} />

      <SidebarAdmin
        mobileOpen={mobileOpen}
        handleDrawerToggle={() => setMobileOpen(!mobileOpen)}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          mt: '60px',
          minHeight: 'calc(100vh - 60px)',
          bgcolor: '#F1F5F9',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default LayoutAdmin;
